import { useState } from 'react';
import { NavLink, Link, useNavigate } from 'react-router-dom';
import { Link as ScrollLink } from 'react-scroll';
import { Navbar, Nav, NavItem, Row, Col, Offcanvas, OffcanvasHeader, OffcanvasBody } from 'reactstrap';
import Logo from '../assets/images/logo/logo-header.png';

const Header = ({ scrollAbout }) => {

  const [offCanvas, setOffCanvas] = useState(false);
  const handleOffCanvas = () => { setOffCanvas(!offCanvas); }

  return (
    <>
      <Navbar expand="md" className="bg-navbar">
        <Row className="w-100 h-100">
          <Col className="d-flex w-100">
            <div className="justify-content-center align-self-center">
              <Link to="/">
                <img src={Logo} className="logo-navbar-top" alt="logo-nitijana" />
              </Link>
            </div>
          </Col>
          <Col className="my-auto text-center">
            <Nav navbar className="d-flex justify-content-center navbar-desktop">
              <NavItem className="px-4">
                <button onClick={scrollAbout} className="border-0 bg-transparent montserrat">
                  Tentang Kami
                </button>
              </NavItem>
            </Nav>
          </Col>
          <Col className="my-auto text-end position-relative">
            <button onClick={handleOffCanvas} className="border-0 bg-transparent hamburger-menu-label text-end">
              <span></span>
              <span></span>
              <span></span>
            </button>
          </Col>
        </Row>
      </Navbar>
      <Offcanvas
        direction="end"
        isOpen={offCanvas}
        toggle={handleOffCanvas}
      >
        <OffcanvasHeader toggle={handleOffCanvas}>
          <Link to="/">
            <img src={Logo} className="logo-navbar-top" alt="logo-nitijana" />
          </Link>
        </OffcanvasHeader>
        <OffcanvasBody className="text-center">
          <ScrollLink to="9" spy={true} smooth={true} onClick={handleOffCanvas} className="border-0 text-dark bg-transparent montserrat">
            Tentang Kami
          </ScrollLink>
        </OffcanvasBody>
      </Offcanvas>
    </>
  )
}

export default Header;